/* eslint-disable */
import React, { useState, useEffect, useCallback, useRef } from "react";
import * as API from "../../framework/API/api";
import { getter } from "@progress/kendo-data-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "../../locale/useTranslation";
import { ENTITYNAME, LOGEVENT, MODULE, TOAST_TYPES } from "../../framework/constant/constant";
import ToastNotification from "../../components/ToastNotification";
import { utility } from "../../framework/utility/utilityProvider";
import { getSelectedState } from "@progress/kendo-react-data-tools";
import { EditPageHeader } from "../../components/EditPageHeader";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import CollectionSelection from "../../framework/forms/CollectionSelection";
import { ScheduleAutoFillFuncListColumns } from "../../framework/utility/customColumns";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";


const DATA_ITEM_KEY = "index";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const AUTOFILL_SCHEDULE_CONF_FUNCS = {
    "ResetAutoFillPlaylistChildren": 1,
    "onReturnSlotDateTimeToPlannedNominalTime": 2,
    "fillUnderOverRunWithStiching": 3, //isKartoonChannel, isGodare, isSMG, isOutdoor, isEcity, isRock, isStarhub
    "ApplyBillBoards": 4, // variationRes
    "ApplyBreakBumpers": 5, // variationRes
    "ManageUnderAndOverRuns": 6, // header_ids, placeAllItemsInLast = false, pullVariations = true, variationData = undefined, checkBackToBackSameCategory = true, mediaTypeEnum = MEDIATYPEENUM.ANY
    "FillFormatSequenceInSchedule": 7, // variationRes, fetchMediaOldStyle, isSMG, keepFillingIfNoSpace
    "PlacingLastPositionItems": 8, //variationRes
    "saveCompleteScheduleChildrenandRefresh": 9,
    "ReplaceItemsToMatchUnderAndOverRunsByBlockExactMatchOnly": 10, //variationRes, autoDeleteOffFooterOffset, realTimeSave = true, mediaTypeEnum = MEDIATYPEENUM.CLOSING
    "ReplaceItemsToMatchUnderAndOverRuns": 11, //variationRes, autoDeleteOffFooterOffset, realTimeSave = true, mediaTypeEnum = MEDIATYPEENUM.CLOSING
    "RefillAndDeleteUnderAndOverRun": 12, //variationRes, autoDeleteOffFooterOffset, fillInLastOnly = false, deleteFooter = true
    "FillFormatSequenceInScheduleBottomUpApproach": 13, // variationRes, fetchMediaOldStyle, isSMG, keepFillingIfNoSpace
    "PlaceRatingSlideAndRatingBug": 14,
    "MoveFirstSegmentBreakItemToLastSegment": 15,
    "PlaceSignOffIdOnLastSegment": 16,
    "PlacingFixedPositionItems": 17, //variationRes
    "PlacingFirstPositionItem": 18, //variationRes
    "MaximumDamageControl": 19, //maxDamageOffset,
    "PackPlaylistFor24Hours": 20 //variationRes
}

const AutoPlaylistConfiguration = (props) => {

    const { SID } = useParams();
    const loc = useLocation();
    const lang = useTranslation();
    const navigate = useNavigate();


    let blankDataItem = {
        SID: SID,
        Description: "",
        Channel: {},
        ExecutionSequence: [],
        Archive: false,
    }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channel, setChannel] = useState([]);
    const [selectedState, setSelectedState] = useState({});
    const [selectedExecutionSequenceState, setSelectedExecutionSequenceState] = useState({});
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [selectedFunction, setSelectedFunction] = useState({});
    const [parameterDataItem, setParameterDataItem] = useState({});

    //MAIN DATA GRID
    const [gridData, setGridData] = useState([]);

    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        loadCombo();
        if (SID > 0) {
            loadEditData();
        }
    }, []);

    const loadEditData = async () => {

        setLoadingStatus(lang.data_loading_error_message);

        let res = await API.getEntity(ENTITYNAME.AutoPlaylistConfiguration, parseInt(SID));

        if (res.success) {
            setDataItem({
                ...res.data,
                Description: loc?.state?.copy ? `Copy of ${res?.data?.Description}` : res?.data?.Description
            });
            // setGridData(mediaData.map((x, i) => ({ ...x, index: i })));
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setLoadingStatus(lang.no_record_found_error_message);
    }

    const loadCombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannel(channelRes.data);
    }

    const onChange = (e) => {
        if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        } else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const onParameterChange = (e) => {
        setParameterDataItem({ ...parameterDataItem, [e.target.name]: e.target.value });
    } 

    const isValid = () => {
        if (dataItem.Description == undefined || dataItem.Description == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_description_error_message });
            return false
        }

        if (Object.keys(dataItem.Channel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false
        }
        
        return true
    }

    const onSave = async () => {
        if (isValid()) {
            const saveData = {
                ...dataItem,
                Channel: {
                    _id: dataItem.Channel._id,
                    SID: dataItem.Channel.SID,
                    FullChannelName: dataItem.Channel.FullChannelName
                },
                checkDuplicate: true,
                query: [["Channel.SID", "=", dataItem.Channel.SID], ["Name", "=", dataItem.Name], ["Archive", "=", false]]
            }

            if (loc?.state?.copy) {
                delete saveData._id;
                saveData.SID = 0;
            }

            delete saveData.index;
            console.log(saveData)
            let res = await API.saveData(ENTITYNAME.AutoPlaylistConfiguration, saveData);
            console.log(res)
            if (res.success) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.AUTO_PLAYLIST_CONFIGURATION, data: res.data, message: res.message };
                API.SaveLogs(logData);
                utility.deleteLocalStorageItem(ENTITYNAME.AutoPlaylistConfiguration);
                onClose();
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        }
    }

    const onAddFunction = () => {
        let newData = { 
            title : selectedFunction.Description,
            description : selectedFunction.Description,
            parameter : parameterDataItem
        }
        setDataItem({...dataItem, ExecutionSequence : [ ...dataItem.ExecutionSequence , newData ] });
        setSelectedFunction({});
        setParameterDataItem({});
    }


    const onSelectionChange = useCallback(
        (event) => {
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });
            setSelectedState(newSelectedState);
        },
        [selectedState]
    );


    const onSearch = (searchText = "") => {
        const keyword = searchText.trim().toLowerCase();
        setSearchText(searchText);

        if (!keyword) {
            // setFilterData(gridData);
            return;
        }

        const filteredData = gridData.filter((item) => {
            const title = item?.Title?.toString().toLowerCase() || "";
            const assetId = item?.AssetId?.toString().toLowerCase() || "";
            return title.includes(keyword) || assetId.includes(keyword);
        });

        // setFilterData(filteredData);
    };


    const onClose = () => {
        if (loc.state && loc.state.prevPath) {
            navigate(loc.state.prevPath)
        } else {
            navigate("/home/autoPlaylistConfiguration");
        }
    }

    const removeFunctionFromGrid = (index) => {
        const updated = [...(dataItem.ExecutionSequence ?? [])];
        updated.splice(index, 1);
        setDataItem({...dataItem, ExecutionSequence : updated})
    };

    const MyCommandCell = (props) => (
        <div className="mt-1 ml-2" style={{ display: "flex"}}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeFunctionFromGrid(props.dataIndex), () => { })} />
        </div>
    )

    return (<>
        <div className="row m-1">
            <div className="col-12">
                <EditPageHeader title={(SID > 0) ? `${lang.edit_autoplaylistconfig_editpage_header}` : `${lang.create_autoplaylistconfig_editpage_header}`} onSubmit={onSave} onCancel={onClose} />
                <div className="row mt-2">
                    <div className="col-4">
                        <label htmlFor="TabView">{lang.description_label} *</label>
                        <input type="text" className="form-control form-control-sm" name="Description" value={dataItem.Description} onChange={onChange} />
                    </div>
                    <div className="col-4">
                        <label htmlFor="TabView">{lang.channel_label} *</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={channel}
                            name="Channel"
                            textField="FullChannelName"
                            dataItemKey="_id"
                            value={dataItem.Channel}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className='col mt-3'>
                        <input type={"checkbox"} name={"Archive"}
                            value={dataItem.Archive}
                            checked={dataItem.Archive}
                            onChange={onChange} />
                        <label className='ml-1'>{lang.archive}</label>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12">
                        
                        <AddRoundButton style={{ marginTop: '5px', backgroundColor: dataItem.IsFetchFromLibrary ? 'lightgray' : '' }} title={lang.add_media_episode_button_tooltip} onClick={onAddFunction} />
                         <div className="col-5" style={{ paddingRight: '0px' }}>
                            <DropDownList
                                data={Object.keys(AUTOFILL_SCHEDULE_CONF_FUNCS).map((f) => { return { 
                                    SID: AUTOFILL_SCHEDULE_CONF_FUNCS[f],
                                    Description: f
                                }})}
                                style={{ backgroundColor: 'white' }}
                                name="func"
                                textField="Description"
                                dataItemKey="SID"
                                value={selectedFunction}
                                onChange={(e) => setSelectedFunction(e.target.value)}
                            />
                        </div>

                        {/* Input Capturing Area  */}
                        {selectedFunction && Object.keys(selectedFunction).length > 0 && <div>

                            {(selectedFunction.SID ==
                                AUTOFILL_SCHEDULE_CONF_FUNCS.ResetAutoFillPlaylistChildren ||
                                AUTOFILL_SCHEDULE_CONF_FUNCS.onReturnSlotDateTimeToPlannedNominalTime ||
                                AUTOFILL_SCHEDULE_CONF_FUNCS.saveCompleteScheduleChildrenandRefresh ||
                                AUTOFILL_SCHEDULE_CONF_FUNCS.PlaceRatingSlideAndRatingBug ||
                                AUTOFILL_SCHEDULE_CONF_FUNCS.MoveFirstSegmentBreakItemToLastSegment ||
                                AUTOFILL_SCHEDULE_CONF_FUNCS.PlaceSignOffIdOnLastSegment) ?

                                <div>

                                    No Parameter needed

                                </div>
                                :

                                <div className="row">

                                    HHEE


                                </div>
                            }


                        </div>}

                        {/* Function Sequence List */}
                        <Grid
                            data={dataItem.ExecutionSequence?.map((item) => ({
                                ...item,
                                [SELECTED_FIELD]: selectedExecutionSequenceState[idGetter(item)],
                            }))}
                            dataItemKey={DATA_ITEM_KEY}
                            selectedField={SELECTED_FIELD}
                            selectable={{
                                enabled: true,
                                drag: false,
                                cell: false,
                                mode: "multiple",
                            }}
                            resizable={true}
                            className="vk-grid"
                            // onSelectionChange={onExclusionSelectionChange}
                            // onHeaderSelectionChange={onExclusionHeaderSelectionChange}
                            style={{ height: "65vh", marginTop: "04px", overflow: "hidden" }}>
                            <GridNoRecords>{loadingStatus}</GridNoRecords>
                            <GridColumn cell={MyCommandCell} width={"55px"} />
                            <GridColumn field="title" title={lang.title_column} editable={false} />
                            <GridColumn field="description" title={lang.description_label} editable={false} />
                            <GridColumn field="parameters" title={lang.parameter_label} editable={false} />
                        </Grid>
                    </div>
                </div>
            </div>


        </div>

    </>)
}

export default AutoPlaylistConfiguration;